import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";

let cache = null;

// Permissões vêm do backend (que também valida cada ação); aqui só escondem botões.
export function usePermissions() {
  const [perms, setPerms] = useState(cache);
  useEffect(() => {
    let alive = true;
    if (!cache) {
      api.get("/permissions").then((r) => {
        cache = new Set(r.data?.permissions || []);
        if (alive) setPerms(cache);
      }).catch(() => { if (alive) setPerms(new Set()); });
    }
    return () => { alive = false; };
  }, []);
  return (name) => Boolean(perms && perms.has(name));
}

export function resetPermissionsCache() { cache = null; }

export function newClientId() {
  const bytes = new Uint8Array(12);
  window.crypto.getRandomValues(bytes);
  return "c" + Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export async function downloadReport(path, params, filename) {
  try {
    const response = await api.get(path, { params, responseType: "blob" });
    const url = URL.createObjectURL(response.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${filename}.${params.formato}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (e) {
    toast.error(apiErr(e) === "[object Blob]" ? "Não foi possível gerar o relatório." : apiErr(e));
  }
}

export const ROW_STYLE = {
  NAO_CONTADO: "bg-slate-800 text-slate-300",
  CONFERE: "bg-emerald-950/60 text-emerald-300",
  DIVERGENTE: "bg-amber-950/60 text-amber-300",
  NAO_ENCONTRADO: "bg-rose-950/60 text-rose-300",
  RECONTAGEM: "bg-violet-950/60 text-violet-300",
  ESTOQUE_MOVIMENTADO: "bg-violet-950/60 text-violet-300",
  CONTAGEM_DUPLICADA: "bg-violet-950/60 text-violet-300",
  APROVADO: "bg-sky-950/60 text-sky-300",
};

export const CATEGORY_STYLE = {
  EXATA: "bg-rose-950/60 text-rose-300 border-rose-700/60",
  ALTA: "bg-amber-950/60 text-amber-300 border-amber-700/60",
  CONFLITANTE: "bg-violet-950/60 text-violet-300 border-violet-700/60",
  POSSIVEL: "bg-slate-800 text-slate-300 border-slate-600",
};

export const INVENTORY_STATUS_STYLE = {
  RASCUNHO: "bg-slate-800 text-slate-300",
  ABERTO: "bg-sky-950/60 text-sky-300",
  EM_CONTAGEM: "bg-sky-900/60 text-sky-200",
  AGUARDANDO_CONFERENCIA: "bg-amber-950/60 text-amber-300",
  AGUARDANDO_APROVACAO: "bg-amber-900/60 text-amber-200",
  FINALIZADO: "bg-emerald-950/60 text-emerald-300",
  CANCELADO: "bg-rose-950/60 text-rose-300",
};

export function diffClass(value) {
  if (value == null || value === 0) return "text-slate-400";
  return value > 0 ? "text-emerald-300" : "text-rose-300";
}

export function signed(value) {
  if (value == null) return "—";
  return value > 0 ? `+${value}` : String(value);
}
